<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" [fullScreen]="true">
  <p style="color: white">Cargando...</p>
</ngx-spinner>
<p-toast position="bottom-right" />